import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';

const ProtectedRoute = ({ component: Component, userLogged, allowedRoles, redirectPath, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) => {
        if (!userLogged) {
          return <Redirect to={redirectPath} />;
        }

        if (allowedRoles.includes(userLogged.role)) {
          return <Component {...props} />;
        } else {
          return <Redirect to={redirectPath} />;
        }
      }}
    />
  );
};

ProtectedRoute.propTypes = {
  component: PropTypes.elementType.isRequired,
  userLogged: PropTypes.object.isRequired,
  allowedRoles: PropTypes.arrayOf(PropTypes.string).isRequired,
  redirectPath: PropTypes.string.isRequired,
};

export default ProtectedRoute;
